// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Qh5ZA","headingWrapper":"Card_headingWrapper__o5Bpp","heading":"Card_heading__gv6fE"};